import {IAnyObject, INumberObject, IStringArrayObject} from "../../../../ts/common/SimpleInterface";
import {FileFormItem, FormItem, IFormProps, IPointer} from "../../../component/form/model/FormModel";
import {PostConfig, PostStatus, PostType} from "../../../../ts/manager/post/PostManager";
import BasicForm from "../../../component/form/BasicForm";
import PostFieldConfig, {
    FieldType,
    IPostFieldConfigItems,
    PostFieldConfigItem, PostFieldSubmitTab
} from "../../../../ts/manager/config/PostFieldConfig";
import {PostDataChoice, PostDataModel} from "../../../../ts/data/subject/PostDataFactory";
import {HttpMethod} from "../../../../ts/common/SimpleType";
import {getManager} from "../../../../ts/manager/Manager";
import {getModelFactory} from "../../../../ts/model-factory/ModelFactory";
import {
    generateHexString, hasAnyValue,
    isArray, isNativeObject, isNumeric,
    requireDate, todayDateAtTime
} from "../../../../ts/common/SiteHelper";
import ApiResponseVO from "../../../../ts/manager/api/ApiResonseVO";
import FileVO from "../../../../ts/common/FileVO";
import ImageVO from "../../../../ts/common/ImageVO";
import ApiError from "../../../../ts/manager/api/ApiError";
import {
    createChildIndexPointer,
    createChildPointer, getParentPointer,
    preparedPointer
} from "../../../component/form/helper/PointerHelper";
import GroupItemFIE from "../../../component/form/form-item-element/GroupItemFIE";
import {JSX} from "react/jsx-runtime";
import RepeaterItemFIE from "../../../component/form/form-item-element/RepeaterFIE";
import InputFIE from "../../../component/form/form-item-element/InputFIE";
import TextAreaFIE from "../../../component/form/form-item-element/TextAreaFIE";
import CheckboxGroupFIE from "../../../component/form/form-item-element/CheckboxGroupFIE";
import SelectFIE from "../../../component/form/form-item-element/SelectFIE";
import DateTimeFIE from "../../../component/form/form-item-element/DateTimeFIE";
import HiddenInputFIE from "../../../component/form/form-item-element/HiddenInputFIE";
import ImageInputFIE from "../../../component/form/form-item-element/ImageInputFIE";
import FileInputFIE from "../../../component/form/form-item-element/FileInputFIE";
import MapLocationFIE from "../../../component/form/form-item-element/MapLocationFIE";
import AppButton from "../../../element/button/AppButton";
import RouteChoice from "../../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../../element/button/RouteChoiceButton";
import React from "react";
import ToggleFIE from "../../../component/form/form-item-element/ToggleFIE";
import RadioGroupFIE from "../../../component/form/form-item-element/RadioGroupFIE";
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";
import DropdownFIE from "../../../component/form/form-item-element/DropdownFIE";
import {AlertOptions} from "@ionic/react";

interface ISavedRepeaterRowIndexes
{
    [key: string]: INumberObject;
}

interface IProps extends IFormProps
{
    postType:PostType|null;
    postID?:number
    organisationID?:number;
}

export default class PostAddEditForm extends BasicForm
{
    props: IProps;

    postType:PostType = null!
    postFields:PostFieldConfig = null!
    postID:number = 0;
    choice:PostDataChoice|null = null;
    routeViewChoice:RouteChoice|null = null;
    applicationsViewChoice:RouteChoice|null = null;
    organisationID:number = 0;
    isOriginallyEdit:boolean = false;
    isCurrentlyEdit:boolean = false;
    isOrganisation:boolean = false;
    canDelete:boolean = false;
    model:PostDataModel = null!;
    parentModel:PostDataModel = null!;
    parentChoice:PostDataChoice|null = null;
    endpoint:string = "/"
    fileEndpoint:string = "/"
    deleteEndpoint:string = "/"
    httpMethod:HttpMethod = "POST"

    fromValues:IAnyObject = {}
    hasUnprocessableError = false;
    postConfig:PostConfig = null!;
    submitText = "";

    savedRepeaterRowIndexes:ISavedRepeaterRowIndexes = {}
    savedRepeaterItemRowIDs:IStringArrayObject = {}
    proceedIfFileInvalid:boolean = true;

    availablePostStatuses:PostStatus[] = [];
    postStatusChoiceList:SimpleChoice[] = [];
    postStatus:PostStatus = "publish";

    failedParentOverrideFieldNames:string[] = [];

    constructor(props: IProps)
    {
        super(props);

        this.props = props;
    }

    initVariables()
    {
        super.initVariables();

        this.postType = this.props.postType ?? "organisation";
        this.postFields = getManager().post.postFieldConfig[this.postType];
        this.postConfig = getManager().post.config[this.postType];
        this.organisationID = this.props.organisationID ?? 0;
        this.isOrganisation = this.postType === "organisation";

        this.model = getModelFactory().postData.getPostDataModel(this.postType, true);

        if(!this.isOrganisation){
            this.parentModel = getModelFactory().postData.getPostDataModel("organisation", true);
        }

        this.postID = this.props.postID ?? 0;
    }

    async initModels(): Promise<void>
    {
        return this.requireModelPopulated().then((apiError) => {
            if(apiError){
                this.isInitializeInvalid = true;
                return
            }
            this.isOriginallyEdit = this.isCurrentlyEdit;
            if(this.parentModel){
                this.parentChoice = this.parentModel.choices[this.organisationID] ?? null;
            }

            this.applyCurrentChoice();
        });
    }

    requireRepeaterIDs(itemID:string, value:IAnyObject[]|null = null): void
    {
        if(!this.modelsInitialized){
            return;
        }
        let rowIDs = this.savedRepeaterItemRowIDs[itemID] ?? null;
        let rowIndexes = this.savedRepeaterRowIndexes[itemID] ?? null;
        if(rowIDs && rowIndexes){
            return;
        }
        rowIDs = [];
        rowIndexes = {};
        if(value){
            for(let i = 0; i < value.length; i++){
                const rowID = generateHexString();
                rowIndexes[rowID] = i;
                rowIDs.push(rowID)
            }
        }
        this.savedRepeaterItemRowIDs[itemID] = rowIDs;
        this.savedRepeaterRowIndexes[itemID] = rowIndexes;
    }

    applyCurrentChoice(retainCurrentForm:boolean = false): void
    {

        this.choice = this.postID ? (this.model.choices[this.postID] ?? null) : null;
        this.routeViewChoice = this.choice ? getModelFactory().getEntryRouteChoice(this.postType, this.choice.postID, false, this.choice.postStatus) : null;
        this.applicationsViewChoice = this.choice ? (getModelFactory().postEntryRoute.getDefaultModel(this.postType, this.choice.postID)?.choices.applications ?? null) : null;
        this.canDelete = !this.isOrganisation && !!this.choice;

        this.isCurrentlyEdit = !!this.postID;
        this.fileEndpoint = "/post/" + this.postType + "/file/add"
        this.deleteEndpoint = "/post/" + this.postType + "/"+ this.postID +"/delete";

        if(!this.isCurrentlyEdit){
            this.httpMethod = "PUT";
            if(this.isOrganisation){
                this.endpoint = "/post/organisation/add";
            } else {
                this.endpoint = "/post/organisation/" + this.organisationID + "/" + this.postType + "/add";
            }
            const prefix = !this.isOrganisation ? "Add " : "Add your ";
            this.submitText = prefix + this.postConfig.name;
        } else {
            this.httpMethod = "POST";
            this.endpoint = "/post/" + this.postType + "/"+ this.postID +"/update";
            this.submitText = "Edit " + this.postConfig.name;
        }

        if(!retainCurrentForm){
            if(this.choice){
                this.fromValues = {
                    ...this.choice.submitValues
                };
                this.postStatus = this.availablePostStatuses.includes(this.choice.postStatus) ? this.choice.postStatus : "publish";
            } else {
                this.fromValues = {};
                this.postStatus = "publish";
            }

            this.savedRepeaterRowIndexes = {};
            this.savedRepeaterItemRowIDs = {};
        }

        this.failedParentOverrideFieldNames.length = 0;


        if(this.parentChoice){
            const checkForRequiredParent = (thisItems:PostFieldConfigItem[], parentValues:IAnyObject): boolean => {
                let anyRequired = false;
                for(let item of thisItems){
                    const parentValue = parentValues[item.name] ?? null;
                    let thisRequired = false;
                    if(item.fieldType === "group"){
                        thisRequired = checkForRequiredParent(item.subFieldList, isNativeObject(parentValue) ? parentValue : {}) || thisRequired;
                    }
                    thisRequired = thisRequired || item.required;
                    if(thisRequired && item.parentOverrideFieldName){
                        if(!hasAnyValue(parentValue)){
                            if(!this.failedParentOverrideFieldNames.includes(item.parentOverrideFieldName)){
                                this.failedParentOverrideFieldNames.push(item.parentOverrideFieldName)
                            }
                        }
                    }
                    anyRequired = anyRequired || thisRequired
                }
                return anyRequired;
            }
            for(let tab of this.postFields.submitTabs){
                checkForRequiredParent(tab.itemList, this.parentChoice.acfMeta);
            }
        }


        let availablePostStatuses:PostStatus[];
        if(this.choice?.postStatus === "pending"){
            availablePostStatuses = ["pending"];
        } else if(this.postType === "organisation"){
            if(this.choice){
                availablePostStatuses = ["publish", "draft"];
            } else {
                availablePostStatuses = ["publish"];
            }
        } else {
            if(this.choice){
                availablePostStatuses = ["publish", "draft", "expired"];
            } else {
                availablePostStatuses = ["publish", "draft"];
            }
        }

        const postStatusChoiceList:SimpleChoice[] = [];
        for(let postStatus of availablePostStatuses){
            let postStatusName:string|null = null;
            if(this.postType === "organisation"){
                if(postStatus === "publish"){
                    postStatusName = "Active";
                } else {
                    postStatusName = "Inactive";
                }
            }
            postStatusChoiceList.push(new SimpleChoice(postStatus, postStatusName ?? getManager().post.postStatusNames[postStatus]));
        }
        this.availablePostStatuses = availablePostStatuses;
        this.postStatusChoiceList = postStatusChoiceList;


    }


    async handleSubmitFileItem(formItem: FileFormItem): Promise<ApiResponseVO>
    {
        const formData = formItem.value.constructFormData(formItem.itemID)
        const responseVO =  await getManager().api.fetchData(this.fileEndpoint, "POST", formData, true, "none");
        const formDataVOs = formItem.value.formDataVOs;
        formItem.value.formDataVOs = [];
        if(responseVO.apiError){
            formItem.value.deleteFileIDs = [];
            return responseVO;
        }
        const fromAttachments = responseVO.data.attachments ?? null;
        let fileVOs:FileVO[] = [];
        if(Array.isArray(fromAttachments)){
            for(let fromAttachment of fromAttachments){
                let fileVO:FileVO
                if(formItem.value.fileType === "image"){
                    fileVO = new ImageVO(fromAttachment);
                } else {
                    fileVO = new FileVO(fromAttachment);
                }
                if(!fileVO.valid){
                    continue;
                }
                fileVOs.push(fileVO);
            }
        }
        if(!fileVOs.length){
            responseVO.apiError = new ApiError(404, "no_attachments", "No attachments found");
            formItem.value.deleteFileIDs = [];
            return responseVO;
        }
        for(let fileID of formItem.value.deleteFileIDs){
            for(let i = 0; i < formItem.value.savedFileVOs.length; i++){
                const savedFileVO = formItem.value.savedFileVOs[i];
                if(savedFileVO.id === fileID){
                    formItem.value.savedFileVOs.splice(i, 1);
                    i --;
                    break;
                }
            }
        }
        formItem.value.deleteFileIDs = [];

        formItem.value.savedFileVOs = formItem.value.savedFileVOs.concat(fileVOs);
        if(fileVOs.length < formDataVOs.length){
            responseVO.apiError = new ApiError(404, "invalid_attachments", "Has invalid attachments");
        }
        return responseVO;
    }

    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const previousPostStatus = this.choice?.postStatus ?? null;
        const params = this.collectParams(formItemIDs);

        const responseVO =  await getManager().api.fetchData(this.endpoint, this.httpMethod, params, true);
        if(responseVO.apiError){
            return responseVO;
        }
        if(!this.postID){
            this.postID = parseInt(responseVO.data.id ?? "0");
            if(!this.postID){
                responseVO.apiError = new ApiError(404, "post_not_found", "Post not found");
                return responseVO;
            }
        }
        this.model.resetPopulatedAndRelated();
        return this.requireModelPopulated().then((apiError:ApiError|null) =>{
            if(apiError){
                responseVO.apiError = new ApiError(404, "fatal_error", "Fatal Error");
                this.hasUnprocessableError = true;
            }
            return responseVO
        });
    }

    async handleDelete(): Promise<ApiResponseVO>
    {
        const responseVO =  await getManager().api.fetchData(this.deleteEndpoint, "DELETE", null, true, "none");
        if(responseVO.apiError){
            return responseVO;
        }
        this.model.resetPopulatedAndRelated();
        this.postID = 0;
        return this.requireModelPopulated().then((apiError:ApiError|null) =>{
            if(apiError){
                responseVO.apiError = new ApiError(404, "fatal_error", "Fatal Error");
                this.hasUnprocessableError = true;
            }
            return responseVO
        });
    }

    confirmationOptions(resolve: ((value: (boolean | PromiseLike<boolean>)) => void), submitType: string): AlertOptions | null
    {
        if(submitType !== "delete"){
            return null;
        }
        return {
            header: '',
            message: 'Are you sure that you want to delete this '+this.postConfig.name.toLowerCase(),
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () =>
                    {
                        resolve(false);
                    },
                },
                {
                    text: 'Delete '+this.postConfig.name,
                    role: 'confirm',
                    handler: () =>
                    {
                        resolve(true);
                    },
                }
            ]
        };
    }

    async onSubmitFailed(responseVO: ApiResponseVO): Promise<void>
    {
        if(this.postID){
            return
        }
        this.postID = parseInt(responseVO.apiError?.info.id ?? "0");
        if(!this.postID){
            return;
        }
        this.model.resetPopulated();
        return this.requireModelPopulated(true).then((apiError:ApiError|null) => {
            if(apiError){
                this.errorTexts = ["Fatal Error"];
                this.hasUnprocessableError = true;
            }
        });
    }


    handleSubmitComplete(responseVO: ApiResponseVO, submitType: string, formItemIDs: string[] | null)
    {
        super.handleSubmitComplete(responseVO, submitType, formItemIDs);
        const postActivityDataModel = getModelFactory().postActivityData.postActivityDataModel(this.organisationID);
        postActivityDataModel.resetPopulated()
    }

    async requireModelPopulated(retainCurrentForm:boolean = false): Promise<ApiError|null>
    {
        const requireModelPopulated = async () =>
        {
            const apiError = await this.model.requirePopulated();
            if (apiError)
            {
                return apiError;
            }
            this.applyCurrentChoice(retainCurrentForm);
            if (this.postID && !this.choice)
            {
                return new ApiError(404, "post_not_found", "Post not found [2]");
            }
            return null;
        }
        if(this.parentModel){
            return this.parentModel.requirePopulated().then((apiError) => {
                if (apiError)
                {
                    return apiError;
                }
                return requireModelPopulated();
            })
        }
        return requireModelPopulated()
    }

    isSubmitDisabled(): boolean
    {
        return super.isSubmitDisabled() || this.hasUnprocessableError;
    }

    isFormItemHidden(formItem: FormItem|PostFieldSubmitTab): boolean
    {
        const parentPointer = formItem instanceof FormItem ? getParentPointer(formItem.pointer) : null
        const parentFormItem = parentPointer ? (this.formItems[parentPointer.itemID!] ?? null) : null;
        if(parentFormItem && this.isFormItemHidden(parentFormItem)){
            return true;
        }
        const getFieldIDs = (pointer:IPointer|null):string[] => {
            if(!pointer){
                return [];
            }
            const fieldIDs = getFieldIDs(pointer.childPointer ?? null);
            fieldIDs.unshift(pointer.fieldID);
            return fieldIDs;
        }
        const getFieldIndexes = (pointer:IPointer|null):(number|null)[] => {
            if(!pointer){
                return [];
            }
            const fieldIndexes = getFieldIndexes(pointer.childPointer ?? null);
            fieldIndexes.unshift(pointer.index ?? null);
            return fieldIndexes;
        }
        const getConfigItem = (fieldIDs:string[], fromItems:IPostFieldConfigItems):PostFieldConfigItem|null => {
            const nextFieldID = fieldIDs[0] ?? null;
            if(!nextFieldID){
                return null;
            }
            fieldIDs.shift();
            const configItem = fromItems[nextFieldID] ?? null;
            if(!configItem || !fieldIDs.length){
                return configItem;
            }
            return getConfigItem(fieldIDs, configItem.subfields);
        }
        const fieldIDs = formItem instanceof FormItem ? getFieldIDs(formItem.pointer) : [];
        const fieldIndexes = formItem instanceof FormItem ? getFieldIndexes(formItem.pointer) : [];
        const configItem = formItem instanceof FormItem ? getConfigItem(fieldIDs.slice(), this.postFields.items) : formItem;
        if(!configItem){
            return false;
        }
        const getFormItemByKey = (key:string):FormItem|null => {
            const configItem = this.postFields.itemsByKey[key] ?? null;
            if(!configItem){
                return null;
            }
            let remainingPath = configItem.path.slice();
            if(configItem.fieldType === "repeater"){
                remainingPath.push([configItem.name])
            } else {
                remainingPath.push(configItem.name)
            }
            let pointer:IPointer|null = null;
            let isPathMatch = true;
            let index= -1;
            for(let pathItem of remainingPath){
                index ++;
                if(!Array.isArray(pathItem)){
                    if(pathItem !== fieldIDs[index]){
                        isPathMatch = false;
                    }
                    pointer = createChildPointer(pathItem, pointer);
                    continue;
                }
                if(!isPathMatch){
                    return null;
                }
                const fieldIndex = fieldIndexes[index] ?? null;
                if(fieldIndex === null){
                    return null;
                }
                const fieldID = pathItem[0] ?? "";
                pointer = createChildPointer(fieldID, pointer);
                pointer = createChildIndexPointer(fieldIndex, pointer);
            }
            return pointer ? (this.formItems[pointer.itemID!] ?? null) : null;
        }

        for(let conditionalLogicGroup of configItem.conditionalLogic){
            for(let conditionalLogicItem of conditionalLogicGroup.items){
                const compareItem = getFormItemByKey(conditionalLogicItem.key);
                if(!compareItem){
                    continue;
                }
                if(this.failedParentOverrideFieldNames.includes(compareItem.fieldID)){
                    continue;
                }
                let conditionalValue = conditionalLogicItem.value ?? "";
                let compareValue = compareItem.getCastValue() ?? "";
                if(compareItem.type === "boolean"){
                    conditionalValue = !!(isNumeric(conditionalValue) ? parseInt(conditionalValue) : conditionalValue);
                    compareValue = !!(isNumeric(compareValue) ? parseInt(compareValue) : compareValue);
                } else if(compareItem.type === "int"){
                    conditionalValue = !isNaN(conditionalValue) ? parseInt(conditionalValue) : null;
                    compareValue = !isNaN(compareValue) ? parseInt(compareValue) : null;
                } else if(compareItem.type === "float"){
                    conditionalValue = !isNaN(conditionalValue) ? parseFloat(conditionalValue) : null;
                    compareValue = !isNaN(compareValue) ? parseFloat(compareValue) : null;
                } else if(isNumeric(conditionalValue) && isNumeric(compareValue)){
                    conditionalValue = parseFloat(conditionalValue);
                    compareValue = parseFloat(compareValue);
                }
                if(conditionalLogicItem.operator === "=="){
                    if(conditionalValue !== compareValue){
                        return true;
                    }
                } else if(conditionalLogicItem.operator === "!="){
                    if(conditionalValue === compareValue){
                        return true;
                    }
                }
            }
        }

        return false;
    }

    renderComponent()
    {
        const buildingName = this.hasFormItem("building_name") ? this.stringItem("building_name").getCastValue() : "";
        const address = this.hasFormItem("address") ? this.stringItem("address").getCastValue() : "";
        const town = this.hasFormItem("town") ? this.stringItem("town").getCastValue() : "";
        const county = this.hasFormItem("county") ? this.stringItem("county").getCastValue() : "";
        const postcode = this.hasFormItem("postcode") ? this.stringItem("postcode").getCastValue() : "";
        const country = this.hasFormItem("country") ? this.stringItem("country").getCastValue() : "";

        const isFieldEmpty = (pointer:IPointer, config:PostFieldConfigItem) => {
            if(config.fieldType !== "group"){
                let formItem:FormItem|null = this.formItems[pointer.itemID!];
                return !formItem || formItem.isEmpty();
            }

            for(let childConfig of config.subFieldList){
                const childPointer = createChildPointer(childConfig.name, pointer);
                const childEmpty = isFieldEmpty(childPointer, childConfig);
                if(!childEmpty){
                    return false;
                }
            }
            return true;
        }

        const renderItemList = (itemList:PostFieldConfigItem[], fromValues:IAnyObject, parentPointer?: IPointer|string):JSX.Element => {
            return <>
                {itemList.map((fieldConfig) =>
                {
                    let colClassName = "col-12 col-lg-6";

                    const col12FieldTypes:FieldType[] = [
                        "group",
                        "repeater",
                        "textarea",
                        "wysiwyg",
                        "checkbox",
                        "radio",
                        "true_false",
                        "map_location",
                        "image"
                    ];

                    const pointer = parentPointer ? createChildPointer(fieldConfig.name, parentPointer) : fieldConfig.name;
                    let fromValue = fromValues[fieldConfig.name];
                    fromValue = (fromValue !== "" && fromValue !== null) ? fromValue : undefined;


                    let currentValue = fromValue ?? (fieldConfig.value ?? fieldConfig.defaultValue);
                    const isFailedParentOverride = this.failedParentOverrideFieldNames.includes(fieldConfig.name);
                    let fieldType = fieldConfig.fieldType;
                    if(isFailedParentOverride){
                        currentValue = undefined;
                        fieldType = "hidden";
                    }
                    if(col12FieldTypes.includes(fieldConfig.fieldType)){
                        colClassName = "col-12";
                    }

                    return <div className={colClassName}
                                key={fieldConfig.name}
                    >
                        {(() => {
                            switch (fieldType) {
                                case "group":
                                    const isEmpty = isFieldEmpty(preparedPointer(pointer), fieldConfig);
                                    const nextFromValues:IAnyObject = isNativeObject(currentValue) ? currentValue : {};
                                    return <GroupItemFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            isChildrenEmpty: isEmpty,
                                            required: fieldConfig.required,
                                        }}
                                        instructions={fieldConfig.instructions}
                                    >
                                        <div className="row">
                                            {renderItemList(fieldConfig.subFieldList, nextFromValues, pointer)}
                                        </div>
                                    </GroupItemFIE>
                                case "repeater":
                                    const repeaterItem = this.repeaterItem(pointer);
                                    currentValue = isArray(currentValue) ? currentValue : [];
                                    this.requireRepeaterIDs(repeaterItem.itemID, currentValue);
                                    const savedRowIDs = this.savedRepeaterItemRowIDs[repeaterItem.itemID] ?? []
                                    const savedRowIndexes = this.savedRepeaterRowIndexes[repeaterItem.itemID] ?? {}
                                    const rowLines:JSX.Element[] = [];
                                    let nextRowIndex = 0;
                                    for(let i = 0 ; i < repeaterItem.currentRowIDs.length;  i ++)
                                    {
                                        const rowID = repeaterItem.currentRowIDs[i];
                                        const rowIndex = savedRowIndexes[rowID] ?? -1;
                                        if(rowIndex >= 0){
                                            nextRowIndex = Math.max(nextRowIndex, rowIndex + 1)
                                        }
                                    }
                                    for(let i = 0 ; i < repeaterItem.currentRowIDs.length;  i ++){
                                        const rowID = repeaterItem.currentRowIDs[i];
                                        let rowIndex = savedRowIndexes[rowID] ?? -1;
                                        if(rowIndex < 0)
                                        {
                                            rowIndex = nextRowIndex;
                                            nextRowIndex ++;
                                        }
                                        const nextFromValues:IAnyObject = (rowIndex >= 0) && isNativeObject(currentValue[rowIndex] ?? null) ? currentValue[rowIndex] : {};
                                        const rowPointer = createChildIndexPointer(i, pointer);
                                        rowLines.push(renderItemList(fieldConfig.subFieldList, nextFromValues, rowPointer))
                                    }
                                    currentValue = this.savedRepeaterItemRowIDs[repeaterItem.itemID] ?? [];
                                    return <RepeaterItemFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            rowMin: fieldConfig.rowMin,
                                            rowMax: fieldConfig.rowMax,
                                            value: savedRowIDs
                                        }}
                                        rowLines={rowLines}
                                        instructions={fieldConfig.instructions}
                                        incrementalTitle={fieldConfig.label}
                                    >
                                    </RepeaterItemFIE>
                                case "text":

                                    return <InputFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                            minlength:fieldConfig.minLength,
                                            maxlength:fieldConfig.maxLength,
                                            min: fieldConfig.minValue,
                                            max: fieldConfig.maxValue,
                                            placeholder:fieldConfig.placeholder,
                                            type: fieldConfig.textFieldType,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue,
                                            type: (fieldConfig.formItemType as "string" | "float" | "int" |undefined),
                                        }}
                                        instructions={fieldConfig.instructions}
                                    />;
                                case "textarea":
                                case "wysiwyg":
                                    return <TextAreaFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                            minlength:fieldConfig.minLength,
                                            maxlength:fieldConfig.maxLength,
                                            placeholder:fieldConfig.placeholder
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        instructions={fieldConfig.instructions}
                                    />;
                                case "checkbox":
                                    return <CheckboxGroupFIE
                                        form={this}
                                        checkboxProps={{
                                            className: fieldConfig.className,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        instructions={fieldConfig.instructions}
                                        choiceList={fieldConfig.choiceList}
                                    />;
                                case "radio":
                                    return <RadioGroupFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        instructions={fieldConfig.instructions}
                                        choiceList={fieldConfig.choiceList}
                                    />;
                                case "true_false":
                                    return <ToggleFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        instructions={fieldConfig.instructions}
                                    />;
                                case "select":
                                    return <SelectFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className,
                                            placeholder:fieldConfig.placeholder
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        instructions={fieldConfig.instructions}
                                        choiceList={fieldConfig.choiceList}
                                    />
                                case "date_time_picker":
                                    currentValue = requireDate(currentValue)
                                    return <DateTimeFIE
                                        form={this}
                                        inputElementProps={{
                                            className: fieldConfig.className,
                                            placeholder:fieldConfig.placeholder
                                        }}
                                        dateElementProps={{
                                            className: fieldConfig.className
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        dateDisplayFormat={fieldConfig.dateDisplayFormat}
                                        instructions={fieldConfig.instructions}
                                        initialDate={fieldConfig.defaultValue ?? todayDateAtTime(1, 9)}
                                        minDate={fieldConfig.minValue}
                                        maxDate={fieldConfig.maxValue}
                                    />
                                case "hidden":
                                    return <HiddenInputFIE
                                        form={this}
                                        elementProps={{
                                            className: fieldConfig.className
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                    />
                                case "image":
                                    return <ImageInputFIE
                                        form={this}
                                        hideCamera={true}
                                        fileElementProps={{
                                            className: fieldConfig.className,
                                            placeholder:fieldConfig.placeholder
                                        }}
                                        imageElementProps={{
                                            className: fieldConfig.className
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        fileUploadSettings={{
                                            mimeTypes: fieldConfig.mimeTypes,
                                            fileCountMin: fieldConfig.fileCountMin,
                                            fileLimit: fieldConfig.fileLimit,
                                            fileSizeMin: fieldConfig.fileSizeMin,
                                            fileSizeMax: fieldConfig.fileSizeMax
                                        }}
                                        instructions={fieldConfig.instructions}
                                    />
                                case "file":
                                    return <FileInputFIE
                                        form={this}
                                        fileElementProps={{
                                            className: fieldConfig.className,
                                            placeholder:fieldConfig.placeholder
                                        }}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        fileUploadSettings={{
                                            mimeTypes: fieldConfig.mimeTypes,
                                            fileCountMin: fieldConfig.fileCountMin,
                                            fileLimit: fieldConfig.fileLimit,
                                            fileSizeMin: fieldConfig.fileSizeMin,
                                            fileSizeMax: fieldConfig.fileSizeMax
                                        }}
                                        instructions={fieldConfig.instructions}
                                    />
                                case "map_location":
                                    return "";/*
                                    return <MapLocationFIE
                                        form={this}
                                        routeProps={this.props.routeProps}
                                        formItemProps={{
                                            pointer: pointer,
                                            name: fieldConfig.label,
                                            required: fieldConfig.required,
                                            value: currentValue
                                        }}
                                        addressRequest={{
                                            country: country,
                                            city: town
                                        }}
                                    />*/
                                default:
                                    return "";
                            }
                        })()}
                    </div>


                })}
            </>

        }

        return <>
            <section className="content-block py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {!!this.applicationsViewChoice && <>
                                <RouteChoiceButton
                                    routeChoice={this.applicationsViewChoice }
                                    label={"Applications"}
                                    className="btn edit-btn reduced me-1"
                                />
                            </>}
                            {!!this.routeViewChoice && <>
                                <RouteChoiceButton
                                    routeChoice={this.routeViewChoice }
                                    label={"View " + this.postConfig.name}
                                    className="btn edit-btn reduced"
                                />
                            </>}
                            {(this.postStatus === "pending") && <>
                                <span className={((!!this.applicationsViewChoice || !!this.routeViewChoice) ? "ps-3 mt-auto" : "mt-3 d-block")+" mb-0 post-status-"+this.postStatus}>{getManager().post.postStatusNames[this.postStatus]}</span>
                            </>}
                        </div>
                    </div>
                </div>
            </section>
            <section className="content-block">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="clearfix">
                                <form
                                    onSubmit={this.handleFormSubmit}
                                    className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                                >

                                    <div className="row">

                                        <div className="col-auto me-auto">

                                        </div>
                                        <div className="col-auto ">
                                            {this.canDelete && <>
                                                <AppButton
                                                    type="submit"
                                                    value="delete"
                                                    loading={this.loading}
                                                    className="btn reduced"
                                                    disabled={this.isSubmitDisabled()}
                                                >
                                                    {"Delete " + this.postConfig.name}
                                                </AppButton>
                                            </>}
                                        </div>
                                        <div className="col-auto ">
                                            {this.postStatusChoiceList.length > 1 && <>
                                                <DropdownFIE
                                                    form={this}
                                                    hideLabel={true}
                                                    formItemProps={{
                                                        pointer: "post_status",
                                                        name: "Post Status",
                                                        required: true,
                                                        value: this.postStatus
                                                    }}
                                                    choiceList={this.postStatusChoiceList}
                                                />
                                            </>}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            {this.startFormAlerts()}
                                        </div>
                                        <div className="col-12">
                                            {this.requiredFieldsMessage()}
                                        </div>
                                    </div>

                                    {this.postFields.submitTabs.map((submitTab, index) =>
                                    {
                                        return <div key={index} className="row">
                                            {!!submitTab.label && !this.isFormItemHidden(submitTab) && <>
                                                <div className="col-12"><h2 className="block-title">{submitTab.label}</h2></div>
                                            </>}
                                            {renderItemList(submitTab.itemList, this.fromValues)}
                                        </div>
                                    })}
                                    <div className="row">
                                        <div className="col-12">
                                            {this.endFormAlerts()}
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group mt-4">
                                                <AppButton
                                                    type="submit"
                                                    loading={this.loading}
                                                    className="btn"
                                                    disabled={this.isSubmitDisabled()}
                                                >
                                                    {this.submitText}
                                                </AppButton>
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>;
    }
}